import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CabeceraEmpresa } from "./cabecera-empresa.component";
import {FormsModule} from '@angular/forms';
import { CabeceraEmpresaService } from "./cabecera-empresa.service";
import { TimerModule } from "../timer/timer.module";

@NgModule({
    declarations: [CabeceraEmpresa],
    imports: [BrowserModule, RouterModule, FormsModule, TimerModule],
    exports:[CabeceraEmpresa],
    providers:[CabeceraEmpresaService]
})

export class CabeceraModuleEmpresa { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabeceraEmpresa/cabecera-empresa.module.ts